import { render, staticRenderFns } from "./BattleCard.vue?vue&type=template&id=6d3c3819&"
import script from "./BattleCard.vue?vue&type=script&lang=js&"
export * from "./BattleCard.vue?vue&type=script&lang=js&"
import style0 from "./BattleCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports